import { createSlice } from '@reduxjs/toolkit'
import { getAllRoles } from './actions'

const initialState = {
  currentProjectRole: null,
  roles: undefined,
  loading: false,
  error: '',
}
const rolesSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setCurrentProjectRole(state, action) {
      state.currentProjectRole = {...action.payload}
    },
    unSetCurrentProjectRole(state) {
      state.currentProjectRole = null
    },
  },
  extraReducers (builder) {
    builder
    .addCase(getAllRoles.pending,(state,action) => {
      state.loading = true
      return state
    })
    .addCase(getAllRoles.fulfilled,(state,action) => {
      state.loading = false
      state.roles = action.payload.data.data.data
    })
    .addCase(getAllRoles.rejected,(state,action) => {
      state.loading = false
      state.error = action.payload.data.message
    })
  }
})
export const {setCurrentProjectRole, unSetCurrentProjectRole} = rolesSlice.actions
export default rolesSlice.reducer


